const tncs = [
  {
    heading: "",
    items: [
      `The MTN Pulse Capture & Share Promo (“Promo”) is a youth-focused promotion on the myMTN App, allowing participants to capture an image from a fast-playing GIF and share/submit it to win prizes. The promo introduces opt-in functionality, leaderboard rankings, and points building through mashup purchases.`,
    ],
  },
  {
    heading: "GENERAL TERMS",
    items: [
      `Exclusive to myMTN App users aged 15-35 years.`,
      `Customers must opt-in via the myMTN App to participate.`,
      `Points are earned through mashup purchases on the app (0.05 mashup = 1 point).`,
      `Top-ranking participants on the leaderboard will gain access to the fast-playing GIF.`,
      `Each customer may capture one image and share it once during the promo period.`,
      `Shared images will be saved to the customer’s profile.`,
    ],
  },
  {
    heading: "REGISTRATION AND PARTICIPATION",
    items: [
      `No registration is required, but opt -in is mandatory via the myMTN App.`,
      `The opt -in period starts before the point - building phase and continues concurrently.`,
      `Participants must fall within the eligible age range(15 - 35 years).`,
      `Leaderboard rankings determine access to the Capture & Share activity.`,
      `By opting in, participants accept these terms and conditions.`,
    ]
  },
  {
    heading: "SUBSCRIPTION CHARGES",
    items: [
      `Subscription to this promo is free.`
    ]
  },
  {
    heading: "PROMOTION DURATION",
    items: [
      `The promo runs from January 22, 2025 to February 14, 2025.`,
      `The duration may be extended at MTN’s discretion.`,
    ]
  },
  {
    heading: "REWARD SCHEME",
    items: [
      `Only mashups on the myMTN App earn leaderboard points.`,
      `Rewards are determined based on leaderboard rankings and GIF submissions.`,
      `Prizes are subject to stock availability and can be tracked through the app.`,
      `Winners must select a delivery location and claim prizes at an MTN Service Center.`,
      `MTN reserves the right to swap unavailable prizes.`
    ],
  },
  {
    heading: "ELIGIBILITY RULES",
    items: [
      `Open to all MTN Pulse customers aged 15 - 35 using the myMTN App.`
    ]
  },
  {
    heading: "ABUSE AND DISQUALIFICATION",
    items: [
      `MTN reserves the right to disqualify participants using fraudulent methods.`,
      `By participating in the MTN Pulse Capture & Share Promo, you agree to these Terms and Conditions.`,
    ]
  },
  {
    heading: "PERSONAL DATA PROTECTION",
    items: [
      `By participating in the Promo, the Customer expressly agree that personal data which they supply shall be processed by the MTN for the purpose of executing the Promo and also for the purpose of publicizing the Promotion and MTN.It is hereby specified that MTN guarantees that publicity, entailing the sharing with third parties of personal data supplied as a result of participation in the Promo, (including through television, the press, leaflets and other means and format of communication) shall be made only with respect to the winners of the prizes and will only indicate the given names and surnames of the winners, their images and voices, made for the sole purpose of publicity connected to the promo).Participation in the promo shall be deemed as winners express consent for the use of this data in the manner herein defined.`,

      `Notwithstanding the above, personal date of the winning participants will be retained by MTN in accordance with the law.`,

      `MTN respects the privacy of Participants of this Promo and accordingly personal data collected during this promo will be treated as private and confidential and in accordance with Data Protection laws of Ghana.`,
    ]
  },
  {
    heading: "GOVERNING LAW & AMENDMENTS",
    items: [
      `This Promotion is organized under and governed by the laws and statutes of Ghana.`,

      `These Terms & Conditions are valid during the Promotion Period until amended or suspended by MTN.`,
    ]
  }
]

const body = tncs.map(tnc => {
  const { heading, items } = tnc;
  return items.map((item, index) => {
    let title = ""
    if (index === 0) title = heading;
    return {
      title,
      details: item
    }
  })
}).flat();

const captuenshareTNC = {
  header: "TERMS AND CONDITIONS: MTN PULSE CAPTURE & SHARE PROMO",
  body
};

export default captuenshareTNC;
